import { TypographyColor } from 'melp-design/components';
import {
  IntegrationLogItemLevel,
  IntegrationStatus,
} from './integrations.types';

export const COLOR_BY_STATUS: Record<IntegrationStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};

export const LOG_ITEM_COLOR_BY_LEVEL: Record<
  IntegrationLogItemLevel,
  TypographyColor
> = {
  info: 'textPrimary',
  warning: 'warning',
  error: 'error',
};
